export const AccountStatus = {
  AWAITING_LOGIN: 'Awaiting first login',
  LOCKED: 'Account Locked',
  OK: 'OK'
};